import { useEffect, useState } from "react";
import { useFeatureFlagValue } from "../../config/FeatureFlagManager/hooks.ts";
import { ThemeToggleButton } from "./ThemeToggleButton.tsx";

const colorSchemeQuery = window.matchMedia("(prefers-color-scheme: dark)");

function getStoredTheme(): "dark" | "light" | null {
  const item: string | null = localStorage.getItem("theme");
  if (item !== "dark" && item !== "light") return null;
  return item as "dark" | "light";
}

function setStoredTheme(theme: "dark" | "light"): void {
  localStorage.setItem("theme", theme);
}
function getBrowserTheme(): "dark" | "light" {
  return colorSchemeQuery.matches ? "dark" : "light";
}

export const ConnectedThemeToggle: React.FC = () => {
  const enableThemeToggle = useFeatureFlagValue("enableThemeToggle");
  const [theme, setTheme] = useState<"dark" | "light">(
    getStoredTheme() || getBrowserTheme(),
  );

  useEffect(() => {
    const listener = (e: MediaQueryListEvent) => {
      setTheme(e.matches ? "dark" : "light");
    };
    colorSchemeQuery.addEventListener("change", listener);
    return () => colorSchemeQuery.removeEventListener("change", listener); // Cleanup listener on unmount
  }, [setTheme]);

  useEffect(() => {
    if (!enableThemeToggle) return; // Skip setting theme if the feature is disabled
    document.documentElement.setAttribute("data-theme", theme);
    setStoredTheme(theme);
  }, [enableThemeToggle, theme]);

  if (!enableThemeToggle) return null; // Return null if the feature is disabled
  return <ThemeToggleButton currentTheme={theme} onThemeChange={setTheme} />;
};
